import React from "react";
import { Link } from "react-router-dom";
import Dialog from "../../common/Dialog";
import Button from "../../core/Button";
import { useIgnoreLocationPermission } from "../hooks/useIgnoreLocationPermission";

interface LocationPermissionDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LocationPermissionDialog: React.FC<
  LocationPermissionDialogProps
> = ({ isOpen, onClose }) => {
  const { setIgnoreLocationPermission } = useIgnoreLocationPermission();

  const handleIgnore = () => {
    setIgnoreLocationPermission();
    onClose();
  };

  return (
    <Dialog
      title="Your Default Map Location"
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <div className="space-y-4 text-left">
        <p className="text-sm text-gray-700">
          We can’t access your location because you have not granted location
          access to Landvoice on your browser. As a result, the map will always
          start off on our default location.
        </p>

        <p className="text-sm text-gray-700">
          To resolve this, do one of the following:
        </p>

        <div className="space-y-3">
          <div>
            <p className="font-semibold text-sm text-gray-800">
              1. Enable Location Access
            </p>
            <p className="text-sm text-gray-600">
              Allow your browser to access your location so we can set your current position as the default.
            </p>
          </div>

          <div>
            <p className="font-semibold text-sm text-gray-800">
              2. Set a Default Address Manually
            </p>
            <p className="text-sm text-gray-600">
            If you prefer not to share your location, you can set a default address in your&nbsp;
              <Link
                to="/accountsettings/neighborhood-search#default-map-location"
                className="text-blue-600 underline hover:text-blue-800"
                onClick={onClose}
              >
                Neighborhood Search Settings
              </Link>
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <Button onClick={handleIgnore} variant="outline">
            Don't ask me again
          </Button>
          <Button onClick={onClose}>
            Maybe Later
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
